export default {
    'games.codelish.com': {
        type: 'users',
        name: 'codelish'
    },
    'games.sonic.family': {
        type: 'users',
        name: 'sergej'
    },
    'games.madden.nyc': {
        type: 'users',
        name: 'rexmadden'
    },
    'stephenkuzma.com': {
        type: 'users',
        name: 'siroinks'
    },
    'www.stephenkuzma.com': {
        type: 'users',
        name: 'siroinks'
    }
}